import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import Language from 'src/config/Language';

import ArticleAPI from 'src/services/api/ArticleAPI';
import ArticlePostModel from 'src/types/article/ArticlePostModel';

import { RECORDS_PER_SET, CATEGORIES } from '../index';

interface Returns {
    basicArticles: ArticlePostModel[];
    additionalArticles: ArticlePostModel[];
    featuredFromOthers: ArticlePostModel[];
    total: number;
    isFetchingBasic: boolean;
    isFetchingAdditional: boolean;
}

// TODO change name
const useFetchBasicListItems: (category: string, page: number) => Returns = (category, page) => {
    const [basicArticles, setBasicArticles] = useState([]);
    const [additionalArticles, setAdditionalArticles] = useState([]);
    const [featuredFromOthers, setFeaturedFromOthers] = useState([]);
    const [total, setTotal] = useState(0);
    const [isFetchingBasic, setIsFetchingBasic] = useState(true);
    const [isFetchingAdditional, setIsFetchingAdditional] = useState(true);
    const { i18n } = useTranslation();

    const language = Language[i18n.language].mediaLocale;

    // TODO move ordering logic back to component

    const fetchBasicItems = async () => {
        setIsFetchingBasic(true);
        setBasicArticles([]);

        const result = await ArticleAPI.getArticleList({ page: 1, category, limit: RECORDS_PER_SET, language });
        if (result.status === 1) {
            setBasicArticles(result.data.hits);
            setTotal(result.data.total);
        }

        const featuredResult = await ArticleAPI.getArticleList({
            page: 1,
            category: CATEGORIES.filter((x) => x !== category),
            limit: RECORDS_PER_SET,
            featured: true,
            language,
        });
        if (featuredResult.status === 1) {
            setFeaturedFromOthers(featuredResult.data.hits.slice(0, 2));
        }

        setIsFetchingBasic(false);
    };

    const fetchAdditionalItems = async () => {
        setIsFetchingAdditional(true);

        const result = await ArticleAPI.getArticleList({ page, category, limit: RECORDS_PER_SET, language });
        if (result.status === 1) {
            setAdditionalArticles(additionalArticles.concat(result.data.hits));
        }

        setIsFetchingAdditional(false);
    };

    // Update items when category changed
    useEffect(() => {
        setAdditionalArticles([]);
        fetchBasicItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category]);

    useEffect(() => {
        if (page <= 1) {
            return;
        }

        fetchAdditionalItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    return {
        basicArticles,
        additionalArticles,
        featuredFromOthers,
        total,
        isFetchingBasic,
        isFetchingAdditional,
    };
};

export default useFetchBasicListItems;
